// eslint-disable-next-line import/order
import styles from "./index.module.scss";
import clsx from "clsx";
// eslint-disable-next-line import/no-unresolved
import "swiper/css";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/navigation";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/free-mode";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/thumbs";
// eslint-disable-next-line import/no-unresolved
import "swiper/css/grid";
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { useEffect, useRef, useState } from "react";
import Icon from "../icon";

export default function Videos({ items = [] }) {
  const [fullScreen, setFullScreen] = useState(false);
  const videoRefs = useRef([]);
  const sliderRef = useRef();
  useEffect(() => {
    const body = document.querySelector("body");
    if (fullScreen) {
      body.classList.add("popup");
    } else {
      body.classList.remove("popup");
    }
  }, [fullScreen]);

  const handleVideoClick = (index) => {
    videoRefs?.current.forEach((video) => {
      if (video.pause) video.pause();
    });
    // Safari отклоняет play() с AbortError, если видео закрыли или переключили
    // до старта; это не ошибка, а в GlitchTip она шла необработанной.
    videoRefs?.current[index].play()?.catch(() => {});
  };

  const handleVideoClose = () => {
    videoRefs?.current.forEach((video) => {
      if (video.pause) video.pause();
    });
  };

  return (
    items?.length > 0 && (
      <div className={styles.Block}>
        <h2>Промо-видео</h2>
        <div className={clsx(fullScreen && styles.FullScreen)}>
          {fullScreen && (
            <span
              className={styles.Close}
              onClick={() => {
                setFullScreen(false);
                handleVideoClose();
              }}
            >
              <Icon
                id="close"
                width={60}
                height={60}
                fill={"#fff"}
                color={"#fff"}
              />
            </span>
          )}
          <Swiper
            ref={sliderRef}
            spaceBetween={10}
            slidesPerView={fullScreen ? 1 : 5}
            navigation={true}
            watchSlidesProgress={true}
            modules={[Navigation]}
            onActiveIndexChange={(swiper) => {
              if (fullScreen) {
                handleVideoClick(swiper.activeIndex);
              }
            }}
            /* breakpoints={{
                        640: {
                            slidesPerView: 3,
                        },
                        768: {
                            slidesPerView: 4,
                        },
                        1024: {
                            slidesPerView: 5,
                        },
                    }} */
          >
            {items.map((item, index) => (
              <SwiperSlide
                key={item.ID}
                onClick={(e) => {
                  e.stopPropagation();
                  if (
                    fullScreen &&
                    index === sliderRef.current.swiper.activeIndex
                  ) {
                    if (videoRefs?.current[index].paused) {
                      videoRefs?.current[index].play()?.catch(() => {});
                    } else {
                      videoRefs?.current[index].pause();
                    }
                  } else {
                    setFullScreen(true);
                    handleVideoClick(index);
                    setTimeout(() => {
                      sliderRef.current.swiper.slideTo(index);
                    });
                  }
                }}
              >
                <div className={styles.Video}>
                  {!fullScreen && (
                    <span
                      style={{ backgroundImage: `url(${item.PREVIEW})` }}
                    ></span>
                  )}
                  {/* eslint-disable-next-line no-return-assign */}
                  <video ref={(el) => (videoRefs.current[index] = el)}>
                    <source src={item.VIDEO} type="video/mp4" />
                  </video>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    )
  );
}
